import { SystemEvents } from '@repo/alt/Services/constants/SystemEvents.js'

import { useCartPricing } from '../composables/useCartPricing'

export default defineNuxtPlugin({
  name: 'promotion-root',
  dependsOn: ['auth-loader:plugin'],
  async setup() {
    const { support: authSupport } = useAuth()
    const bus = useBus()
    const selectedItems = ref([])

    const { syncPromoFromServer } = useCartPricing(selectedItems, {
      immediate: false,
    })

    async function restorePromoCode() {
      if (!authSupport.checkAuth()) {
        return
      }

      await syncPromoFromServer()
    }

    if (authSupport.checkAuth()) {
      await restorePromoCode()
    }

    if (import.meta.client) {
      bus.on(SystemEvents.LOGGED_IN, () => {
        restorePromoCode()
      })
    }
  },
})
